import angular from 'angular'
import isNaN from 'lodash/isNaN'
import isNumber from 'lodash/isNumber'
import isBoolean from 'lodash/isBoolean'
import { round } from 'vend-number'

const DEFAULT_DECIMAL_PLACES = 2
const DEFAULT_TRIM_INSIGNIFICANT = false

/**
 * Round a given number to 2 (or otherwise specified) decimal places, optionally trimming insignificant 0s.
 *
 * @param input
 *        The number to round
 *
 * @param decimalPlaces
 *        The number of decimal places to round to (defaults to 2)
 *
 * @param trimInsignificant
 *        Whether to trim insignificant 0s (defaults to false)
 *
 * @return The given number rounded to the specified number of decimal places
 */
export function displayRound(
  input: string | number,
  decimalPlaces?: number,
  trimInsignificant?: boolean
) {
  let rounded

  if (isBoolean(decimalPlaces)) {
    trimInsignificant = decimalPlaces
  }

  trimInsignificant = isBoolean(trimInsignificant)
    ? trimInsignificant
    : DEFAULT_TRIM_INSIGNIFICANT
  decimalPlaces = isNumber(decimalPlaces)
    ? decimalPlaces
    : DEFAULT_DECIMAL_PLACES

  // Round valid input. If the input is invalid and can't be rounded, number.round will throw an error.
  // Instead of breaking here, swallow the error and leave validation to the controller.
  try {
    rounded = round(input, decimalPlaces)
  } catch (e) {
    rounded = input
  }

  if (trimInsignificant) {
    // Trim insignificant figures if possible, otherwise return the raw value for the validator to handle.
    rounded = !isNaN(parseFloat(rounded as string))
      ? parseFloat(rounded as string).toString()
      : rounded
  }

  return rounded
}

angular.module('webregister.filters').filter('displayRound', () => displayRound)
